<script lang="ts" setup>
const { canShowDashboardChart, canShowDashboardDemands, canShowDashboardOrders, canCreateOrder, canCreateDemand } =
    useAppPermissions();
</script>
<template>
    <page-base :show-header-image="true">
        <template #header>
            <page-header :title="$t('dashboard.title')" :subtitle="$t('app.short-name')">
                <contained-btn v-if="canCreateDemand()" :to="{ name: 'demands-new' }">{{
                    $t('demands.overview.actions.new')
                }}</contained-btn>
                <contained-btn v-if="canCreateOrder()" class="q-ml-md" :to="{ name: 'orders-new' }">{{
                    $t('orders.overview.actions.new')
                }}</contained-btn>
            </page-header>
            <home-page-dashboard v-if="canShowDashboardChart()" />
        </template>

        <orders-latest-table v-if="canShowDashboardOrders()" />
        <demands-latest-table v-if="canShowDashboardDemands()" />
    </page-base>
</template>
